import { StaticQuery, graphql } from "gatsby";
import React from "react";

import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";

export const Resources = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query ResourcesResourcesHeroImageQuery {
          file(relativePath: { eq: "brochures.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 65% center;
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 526px;
        }
      `}
    >
      <Header2
        css={`
          @media screen and (min-width: ${getSize("desktop1200")}) {
            font-size: 48px;
            line-height: 58px;
          }
        `}
      >
        {"Resources"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize("desktop1200")}) {
            font-size: 20px;
            line-height: 31px;
          }
        `}
      >
        {
          "Savant Power Microgrid components information and other assets available for download here."
        }
      </Paragraph>
    </Card>
  </Section>
);

Resources.propTypes = {};
